/* tslint:disable */
/* eslint-disable */
/**
 * Main data new API
 * Auto-generated openapi scheme for main-data-new API
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    TCOOutputFloat,
    TCOOutputFloatFromJSON,
    TCOOutputFloatFromJSONTyped,
    TCOOutputFloatToJSON,
    TCOOutputInteger,
    TCOOutputIntegerFromJSON,
    TCOOutputIntegerFromJSONTyped,
    TCOOutputIntegerToJSON,
} from './';

/**
 * 
 * @export
 * @interface TCOOutputDetailsDiesel
 */
export interface TCOOutputDetailsDiesel {
    /**
     * 
     * @type {TCOOutputInteger}
     * @memberof TCOOutputDetailsDiesel
     */
    year: TCOOutputInteger;
    /**
     * 
     * @type {TCOOutputFloat}
     * @memberof TCOOutputDetailsDiesel
     */
    mileage: TCOOutputFloat;
    /**
     * 
     * @type {TCOOutputFloat}
     * @memberof TCOOutputDetailsDiesel
     */
    purchaseCost: TCOOutputFloat;
    /**
     * 
     * @type {TCOOutputFloat}
     * @memberof TCOOutputDetailsDiesel
     */
    insuranceCost: TCOOutputFloat;
    /**
     * 
     * @type {TCOOutputFloat}
     * @memberof TCOOutputDetailsDiesel
     */
    serviceAndMaintenanceCost: TCOOutputFloat;
    /**
     * 
     * @type {TCOOutputFloat}
     * @memberof TCOOutputDetailsDiesel
     */
    fuelCost: TCOOutputFloat;
    /**
     * 
     * @type {TCOOutputFloat}
     * @memberof TCOOutputDetailsDiesel
     */
    fuelPrice: TCOOutputFloat;
    /**
     * 
     * @type {TCOOutputFloat}
     * @memberof TCOOutputDetailsDiesel
     */
    fuelAverageConsumption: TCOOutputFloat;
    /**
     * 
     * @type {TCOOutputFloat}
     * @memberof TCOOutputDetailsDiesel
     */
    totalConsumptionOfFuel: TCOOutputFloat;
    /**
     * 
     * @type {TCOOutputFloat}
     * @memberof TCOOutputDetailsDiesel
     */
    tollCost: TCOOutputFloat;
    /**
     * 
     * @type {TCOOutputFloat}
     * @memberof TCOOutputDetailsDiesel
     */
    otherCost: TCOOutputFloat;
    /**
     * 
     * @type {TCOOutputFloat}
     * @memberof TCOOutputDetailsDiesel
     */
    totalCost: TCOOutputFloat;
    /**
     * 
     * @type {TCOOutputFloat}
     * @memberof TCOOutputDetailsDiesel
     */
    gCo2PerUnitProduction: TCOOutputFloat;
    /**
     * 
     * @type {TCOOutputFloat}
     * @memberof TCOOutputDetailsDiesel
     */
    residualValue: TCOOutputFloat;
    /**
     * 
     * @type {TCOOutputFloat}
     * @memberof TCOOutputDetailsDiesel
     */
    adblueCosts: TCOOutputFloat;
    /**
     * 
     * @type {TCOOutputFloat}
     * @memberof TCOOutputDetailsDiesel
     */
    adbluePrice: TCOOutputFloat;
    /**
     * 
     * @type {TCOOutputFloat}
     * @memberof TCOOutputDetailsDiesel
     */
    adblueAverageConsumption: TCOOutputFloat;
    /**
     * 
     * @type {TCOOutputFloat}
     * @memberof TCOOutputDetailsDiesel
     */
    totalConsumptionOfAdblue: TCOOutputFloat;
}

export function TCOOutputDetailsDieselFromJSON(json: any): TCOOutputDetailsDiesel {
    return TCOOutputDetailsDieselFromJSONTyped(json, false);
}

export function TCOOutputDetailsDieselFromJSONTyped(json: any, ignoreDiscriminator: boolean): TCOOutputDetailsDiesel {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'year': TCOOutputIntegerFromJSON(json['year']),
        'mileage': TCOOutputFloatFromJSON(json['mileage']),
        'purchaseCost': TCOOutputFloatFromJSON(json['purchase_cost']),
        'insuranceCost': TCOOutputFloatFromJSON(json['insurance_cost']),
        'serviceAndMaintenanceCost': TCOOutputFloatFromJSON(json['service_and_maintenance_cost']),
        'fuelCost': TCOOutputFloatFromJSON(json['fuel_cost']),
        'fuelPrice': TCOOutputFloatFromJSON(json['fuel_price']),
        'fuelAverageConsumption': TCOOutputFloatFromJSON(json['fuel_average_consumption']),
        'totalConsumptionOfFuel': TCOOutputFloatFromJSON(json['total_consumption_of_fuel']),
        'tollCost': TCOOutputFloatFromJSON(json['toll_cost']),
        'otherCost': TCOOutputFloatFromJSON(json['other_cost']),
        'totalCost': TCOOutputFloatFromJSON(json['total_cost']),
        'gCo2PerUnitProduction': TCOOutputFloatFromJSON(json['g_co2_per_unit_production']),
        'residualValue': TCOOutputFloatFromJSON(json['residual_value']),
        'adblueCosts': TCOOutputFloatFromJSON(json['adblue_costs']),
        'adbluePrice': TCOOutputFloatFromJSON(json['adblue_price']),
        'adblueAverageConsumption': TCOOutputFloatFromJSON(json['adblue_average_consumption']),
        'totalConsumptionOfAdblue': TCOOutputFloatFromJSON(json['total_consumption_of_adblue']),
    };
}

export function TCOOutputDetailsDieselToJSON(value?: TCOOutputDetailsDiesel | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'year': TCOOutputIntegerToJSON(value.year),
        'mileage': TCOOutputFloatToJSON(value.mileage),
        'purchase_cost': TCOOutputFloatToJSON(value.purchaseCost),
        'insurance_cost': TCOOutputFloatToJSON(value.insuranceCost),
        'service_and_maintenance_cost': TCOOutputFloatToJSON(value.serviceAndMaintenanceCost),
        'fuel_cost': TCOOutputFloatToJSON(value.fuelCost),
        'fuel_price': TCOOutputFloatToJSON(value.fuelPrice),
        'fuel_average_consumption': TCOOutputFloatToJSON(value.fuelAverageConsumption),
        'total_consumption_of_fuel': TCOOutputFloatToJSON(value.totalConsumptionOfFuel),
        'toll_cost': TCOOutputFloatToJSON(value.tollCost),
        'other_cost': TCOOutputFloatToJSON(value.otherCost),
        'total_cost': TCOOutputFloatToJSON(value.totalCost),
        'g_co2_per_unit_production': TCOOutputFloatToJSON(value.gCo2PerUnitProduction),
        'residual_value': TCOOutputFloatToJSON(value.residualValue),
        'adblue_costs': TCOOutputFloatToJSON(value.adblueCosts),
        'adblue_price': TCOOutputFloatToJSON(value.adbluePrice),
        'adblue_average_consumption': TCOOutputFloatToJSON(value.adblueAverageConsumption),
        'total_consumption_of_adblue': TCOOutputFloatToJSON(value.totalConsumptionOfAdblue),
    };
}


